import script from "./PhoneConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./PhoneConfirmation.vue?vue&type=style&index=0&id=9f9973da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f9973da"]])

export default __exports__